/**
 * Tech Panel Question Bank — thin wrapper over the shared ChecklistBankPage.
 * Industry → Department → Role + Work Assessment category scoping + CSV bulk
 * upload (mirrors Tech Assessment Bank taxonomy).
 */
import React from 'react';
import { ChecklistBankPage } from './ChecklistBankPage';

export default function PanelBank() {
  return (
    <ChecklistBankPage
      pageTitle="Tech Panel Questions"
      pageSubtitle="Master checklist for tech-panel interviewers. Each question is scoped to Industry → Department → Role plus a Work Assessment category, and carries a model answer and red flags."
      apiPath="/questions/panel"
      queryKey={['v1-panel-qs']}
      withDifficulty
      withDepartmentCategory
      showBulkUpload
      bulkKind="panel"
      testIdPrefix="panel-bank"
      editPermission="bank.panel.edit"
    />
  );
}
